<template>
    <div>
        <div class="holder">
            <h2 id="page-header"><router-link to="/">My Arlington - Projects Search</router-link></h2>
        </div>
        <div class="layer-page">
            <div class="widget one-third filter-pane">
                <div id="blurb">
                    <p>
                        Search for projects
                    </p>
                </div>
                <div class="filter-container">
                    <label for="project-search">Search projects</label>
                    <br/>
                    <input type="search" id="project-search" v-model="search" autocomplete="off" />
                </div>
            </div>
            <div class="widget full-map-pane">
                <ul>
                  <li v-for="project in filteredProjects" :key="project.id"><router-link :to="{ name: 'Project', params: { id: project.id } }">{{project.title}}</router-link></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data () {
    return {
      search: ''
    }
  },
  computed: {
    ...mapGetters(['projects']),
    filteredProjects () {
      if (this.search === '') {
        return this.projects;
      } else {
        const regex = new RegExp(this.search, 'i');

        return this.projects.filter(p => p.title && p.title.match(regex));
      }
    }
  },
  methods: {
    ...mapActions(['loadProjects'])
  },
  mounted () {
    this.loadProjects();
  }
}
</script>



// WEBPACK FOOTER //
// Search.vue?0143799f